import { render, staticRenderFns } from "./kalemsigorta.vue?vue&type=template&id=15d08e90"
import script from "./kalemsigorta.vue?vue&type=script&lang=js"
export * from "./kalemsigorta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports